<template>
  <modal :show.sync="show" :on-close="onClose">
    <div class="column content-box">
      <woot-modal-header
        :header-title="$t('AGENT_BOT_MANAGEMENT.ADD.HEADER_TITLE')"
        :header-content="$t('AGENT_BOT_MANAGEMENT.ADD.HEADER_CONTENT')"
      />

      <agent-bot-form
        :is-submitting="loading"
        @submit="createAgentBot"
        :on-close="onClose"
      />
    </div>
  </modal>
</template>

<script>
import Modal from '../../../../components/Modal';
import alertMixin from 'shared/mixins/alertMixin';
import AgentBotForm from './Form';

export default {
  components: {
    Modal,
    AgentBotForm,
  },
  mixins: [alertMixin],
  props: {
    onClose: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      show: true,
    };
  },
  methods: {
    createAgentBot(formData) {
      
      this.loading = true;

      this.$store
        .dispatch('createAgentBotManagement', formData)
        .then(() => {
          this.loading = false;
          this.showAlert(this.$t('AGENT_BOT_MANAGEMENT.ADD.SUCCESS'));
          this.onClose();
        })
        .catch(error => {
          this.loading = false;
          const errorMessage =
            error?.message || this.$t('AGENT_BOT_MANAGEMENT.ADD.ERROR');
          this.showAlert(errorMessage);
        });
    },
  },
};
</script>